<ng-container *ngIf="contact != null">
    <span class="badge">{{
        contact.type == 'CUSTOM' ? contact.subtype : 'Aerodrome'
    }}</span>
    {{ contact.name }}:
    {{ contact.value }}
</ng-container>
